import React, { Fragment, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import {
  chatMessage,
  modChatMessage,
  deleteChatMessage,
} from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { getProfileById } from "../../actions/profile";
import { getSubscriptions } from "../../actions/subscribe";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import OnlineUsers from "../layout/IME/OnlineUsers";
import RecommendedUsers from "../layout/IME/RecommendedUsers";
import MentorStreamVideo from "../layout/Mentors/MentorStreamVideo";
import StreamChatRed from "../layout/Mentors/StreamChatRed";
import ModChat from "../layout/Mentors/ModChat";
// import ReportUser from "../layout/IME/ReportUser";
import Subscribe from "../layout/IME/Subscribe";
import GiftSubscription from "../layout/IME/GiftSubscription";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import MentorChatRules from "../layout/Mentors/MentorChatRules";
import MentorStreamSchedule from "../layout/Mentors/MentorStreamSchedule";
import AboutMentor from "../layout/Mentors/AboutMentor";
import MentorSocial from "../layout/Mentors/MentorSocial";
import Approvals from "../layout/Mentors/Approvals";
import CancelSubscription from "../layout/IME/CancelSubscription";

const ENDPOINT = process.env.REACT_APP_SOCKET_SERVER_URL;

const stripePromise = loadStripe("pk_test_R5aeBnKS8t0F6DGs66ocdQMn00DO67h13Z");

let socket;

const MentorStream = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  getGifs,
  gif: { gifs, loading },
  profile: { profile },
  subscribe: { subscriptions, subscribers },
  getProfileById,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  getSubscriptions,
  isAuthenticated,
}) => {
  const [participant, setParticipant] = useState({
    id: "",
    channelid: user.channelid,
    role: user.role,
    avatar: user.avatar,
    firstname: user.firstname,
    lastname: user.lastname,
    room: match.params.channelid,
  });
  const [userIndex, setUserIndex] = useState(-1);
  const [liveLinks, setLiveLinks] = useState([]);
  const [showGIFs, setshowGIFs] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [showModGIFs, setshowModGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [modGifSearch, setModGifSearch] = useState(false);
  const [text, setText] = useState("");
  // const [modtext, setModText] = useState("");
  const [foundGif, setGif] = useState("");
  const [foundModGif, setModGif] = useState("");
  const [message, setMessage] = useState("");
  const [modmessage, setModMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [modmessages, setModMessages] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_red.png");
  const [showChat, setShowChat] = useState(true);
  const [showModChat, setShowModChat] = useState(false);
  const [showSubscription, setshowSubscription] = useState(false);
  const [showGiftSubscription, setshowGiftSubscription] = useState(false);
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [showCancelSubscription, setshowCancelSubscription] = useState({
    request: false,
    confirm: false,
  });

  let subscriber;

  if (subscribers && user) {
    subscriber = subscribers.find((x) => x.subscriber === user.user);
  }

  const deleteMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = messages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  const deleteModMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = modmessages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    modmessages.splice(removeIndex, 1);

    setModMessages([...modmessages]);
  };

  useEffect(() => {
    getGifs();
    getSubscriptions();
    getProfileById(match.params.channelid);
    setRoom(match.params.channelid);
  }, [getGifs, getSubscriptions, getProfileById, match.params.channelid, room]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      setParticipant({
        channelid: user.channelid,
        role: user.role,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        role: user.role,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });

      socket.on("getRequests", (userRequests) => {
        setLiveLinks([...userRequests]);
      });
    }

    return () => {
      socket.emit("disconnect");

      socket.off();
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    if (liveLinks.length > 0) {
      const foundIndex = liveLinks
        .map((user) => user.channelid)
        .indexOf(participant.channelid);
      setUserIndex(foundIndex);
    }
  }, [liveLinks]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  useEffect(() => {
    socket.on("modmessage", (modmessage) => {
      setModMessages([...modmessages, modmessage]);
    });
  }, [modmessages]);

  const sendModMessage = (e) => {
    e.preventDefault();
    if (modmessage || foundModGif !== "") {
      modChatMessage(match.params.channelid, modmessage, foundModGif);
      socket.emit(
        "modChatMessage",
        modmessage,
        foundModGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setModMessage("");
      setModGif("");
      setshowModGIFs(false);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      chatMessage(match.params.channelid, message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  const sendRequest = () => {
    socket.emit("sendRequest", participant);
    setRequestSent(true);
  };

  const removeRequest = (channelid) => {
    setLiveLinks(liveLinks.filter((item) => item.id !== channelid));
    socket.emit("removeRequest", participant);
    setRequestSent(false);
  };

  useEffect(() => {
    socket.on("sendRequests", (userRequests) => {
      setLiveLinks(userRequests);
    });
  }, [liveLinks]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {/* <ReportUser /> */}
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {showSubscription && (
        <Elements stripe={stripePromise}>
          <Subscribe
            setshowSubscription={setshowSubscription}
            profile={profile}
          />
        </Elements>
      )}
      {showCancelSubscription.request && (
        <CancelSubscription
          setshowCancelSubscription={setshowCancelSubscription}
          profile={profile}
          subscriber={subscriber}
        />
      )}
      {showGiftSubscription && (
        <Elements stripe={stripePromise}>
          <GiftSubscription
            profile={profile}
            setshowGiftSubscription={setshowGiftSubscription}
          />
        </Elements>
      )}
      {isAuthenticated && <LoggedInNavRed />}
      {!isAuthenticated && <LoggedOutNav />}
      <div
        className={showChat || showModChat ? "flex-only-alt" : "flex-no-chat"}
      >
        <div className="side-container border-right grey">
          {isAuthenticated && <OnlineUsers />}
          {!isAuthenticated && <RecommendedUsers />}
        </div>
        <div className="main-stream-content">
          <div className="video-chat">
            <MentorStreamVideo showChat={showChat} profile={profile} />
            {!showChat && !showModChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x red"></i>
              </div>
            )}
          </div>
          {liveLinks.length > 0 && isAuthenticated && userIndex >= 0 && (
            <div className="queue-position red bold">
              Position in queue: {userIndex + 1}
              <div onClick={removeRequest} class="action-items-stream-alt">
                <div class="action-button red">
                  <i class="fas fa-user-minus action-icon fa-lg"></i>
                </div>
                <p class="action-text">
                  Live Link requested! Click the icon to remove your pending
                  request.
                </p>
              </div>
            </div>
          )}
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                    className="streamer-user-avi"
                  />
                  <div className="helper-container">
                    <p className="stream-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                    <div className="stream-lower-info">
                      <ul className="creator-stream-items">
                        <li className="stream-item red bold">
                          {profile.channelid}
                        </li>
                        <li className="stream-item">
                          {profile.firstname} {profile.lastname}
                        </li>
                        <li className="stream-item">{profile.jobtitle}</li>
                        <li className="stream-item">
                          {profile.location && profile.location.city},{" "}
                          {profile.location && profile.location.state}
                        </li>
                        <li className="stream-item">
                          <i className="far fa-clock mr-5 red"></i>
                          Date
                        </li>
                      </ul>
                      <ul className="user-count-items">
                        <li className="user-count-item">
                          <i className="fas fa-user-friends fa-lg mr-5 red"></i>
                          <span className="red mr-5 bold">Friends</span>
                          <span className="white bold">552</span>
                        </li>
                        <li className="user-count-item">
                          <i className="fas fa-user-check fa-lg mr-5 red"></i>
                          <span className="red mr-5 bold">Subscribers</span>
                          <span className="white bold">5,852</span>
                        </li>
                        <li className="user-count-item">
                          <i className="fas fa-check fa-lg mr-5 red"></i>
                          <span className="red mr-5 bold">Followers</span>
                          <span className="white bold">5,852</span>
                        </li>
                      </ul>
                      <div className="action-buttons">
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button red">
                              <i className="far fa-thumbs-up action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">5,768</p>
                          </div>
                        )}
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button red">
                              <i className="far fa-thumbs-down action-icon fa-lg"></i>
                            </div>
                          </div>
                        )}
                        <div className="action-items-stream">
                          <div className="action-button red">
                            <i className="far fa-user action-icon-alt-two fa-lg"></i>
                          </div>
                          <p className="action-text">5,768</p>
                        </div>
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button red">
                              <i className="far fa-share-square action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">Share</p>
                          </div>
                        )}
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button red">
                              <i className="fas fa-donate action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">Donate</p>
                          </div>
                        )}
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div
                              className="action-button red"
                              onClick={() => setshowGiftSubscription(true)}
                            >
                              <i className="fas fa-gift action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">Gift</p>
                          </div>
                        )}
                        {isAuthenticated &&
                          user.channelid !== profile.channelid && (
                            <div className="action-items-stream">
                              <div className="action-button red">
                                <i className="fas fa-check action-icon fa-lg"></i>
                              </div>
                              <p className="action-text">Follow</p>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container">
                {isAuthenticated && subscriptions.length <= 0 && (
                  <div
                    className="action-items-stream-alt"
                    onClick={() => setshowSubscription(true)}
                  >
                    <div className="action-button red">
                      <i className="fas fa-user-check action-icon fa-lg"></i>
                    </div>
                    <p className="action-text">Subscribe</p>
                  </div>
                )}
                {isAuthenticated &&
                  subscriptions.length > 0 &&
                  subscriptions.map((subscription) => {
                    if (
                      subscription.channelid === profile.channelid &&
                      subscription.active &&
                      subscription.autorenew
                    ) {
                      return (
                        <div className="friend-buttons-container">
                          <div className="action-items red">
                            <div
                              className="action-button"
                              onClick={() =>
                                setshowCancelSubscription({
                                  request: true,
                                  confirm: false,
                                })
                              }
                            >
                              <i className="fas fa-medal action-icon-users fa-lg"></i>
                            </div>
                            <p className="action-text">Subscribed</p>
                          </div>
                        </div>
                      );
                    }
                  })}
                {isAuthenticated &&
                  !requestSent &&
                  user.channelid !== profile.channelid && (
                    <div className="action-items-stream-alt">
                      <div
                        onClick={() => {
                          sendRequest();
                        }}
                        className="action-button red"
                      >
                        <i className="fas fa-link action-icon fa-lg"></i>
                      </div>
                      <p className="action-text">Request Live Link</p>
                    </div>
                  )}
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <MentorChatRules />
          <MentorStreamSchedule />
          <AboutMentor />
          <MentorSocial profile={profile} />
          <Approvals />
        </div>
        {showModChat && !showChat && user.channelid === profile.channelid && (
          <ModChat
            user={user}
            profile={profile}
            modmessages={modmessages}
            modmessage={modmessage}
            setModMessage={setModMessage}
            deleteModMessage={deleteModMessage}
            gifs={gifs}
            setModGif={setModGif}
            foundModGif={foundModGif}
            showModGIFs={showModGIFs}
            setshowModGIFs={setshowModGIFs}
            modGifSearch={modGifSearch}
            setModGifSearch={setModGifSearch}
            sendModMessage={sendModMessage}
            text={text}
            setShowModChat={setShowModChat}
            setShowChat={setShowChat}
          />
        )}
        {showChat && !showModChat && (
          <StreamChatRed
            user={user}
            profile={profile}
            messages={messages}
            message={message}
            setMessage={setMessage}
            deleteMessage={deleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
            setShowModChat={setShowModChat}
          />
        )}
      </div>
    </Fragment>
  );
};

MentorStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  subscribe: PropTypes.object.isRequired,
  getProfileById: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  modChatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  subscribe: state.subscribe,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getSubscriptions,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  getGifs,
  getGifsSearch,
})(MentorStream);
